import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { pushParams, resetParams } from 'dpl/actions/query_params';
import { FILTER_GENDER } from 'dpl/constants/query_params';
import Checkbox from 'dpl/form/components/Checkbox';

import FilterDrawer from './FilterDrawer';

export default function GenderFilter() {
  const queryParams = useSelector(state => state.queryParams);
  const { genderOptions } = useSelector(({ server }) => server);
  const dispatch = useDispatch();

  function handleFilterChange(e) {
    const { value, checked } = e.target;
    const paramValue = queryParams[FILTER_GENDER];
    const genderFilterValues = genderOptions.map(go => go.value);

    if (checked) {
      if (genderFilterValues.includes(paramValue)) {
        dispatch(pushParams({ [FILTER_GENDER]: 'any' }, { hash: true }));
      } else {
        dispatch(pushParams({ [FILTER_GENDER]: value }, { hash: true }));
      }
    } else if (paramValue === value) {
      dispatch(resetParams(FILTER_GENDER, { hash: true }));
    } else if (paramValue === 'any') {
      const oppositeValue = genderFilterValues.find(v => v !== value) || '';

      dispatch(pushParams({ [FILTER_GENDER]: oppositeValue }, { hash: true }));
    }
  }

  return (
    <FilterDrawer className="BreederSearchResultsGenderFilter" title="Gender">
      {genderOptions.map(opt => (
        <div key={opt.value} className="mb4">
          <Checkbox
            id={`${FILTER_GENDER}_${opt.value}`}
            name={`${FILTER_GENDER}_${opt.value}`}
            title={opt.title}
            value={opt.value}
            checked={[opt.value, 'any'].includes(queryParams.gender)}
            onChange={handleFilterChange}
          />
        </div>
      ))}
    </FilterDrawer>
  );
}
